export function sortVirtualSupporters(supporters) {
  // Validate input
  if (!Array.isArray(supporters)) {
    throw new Error("Expected an array of supporters");
  }
  // Map to { name } objects and sort by name
  return supporters
    .map((s) => ({ name: s.virtualSupporter }))
    .sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
}

export function filterVirtualSupporters(supporters) {
  if (!Array.isArray(supporters)) {
    throw new Error("Expected an array of supporters");
  }
  return supporters.filter(
    (s) => typeof s.virtualSupporter === "string" && s.virtualSupporter.trim() !== ""
  );
}
